module.exports = __webpack_public_path__ + "static/media/Group@2x.3d4cc9c2.png";